export default {
  text: 'Ved at bruge denne hjemmeside accepterer du vores',
  cookie_policy: 'Cookiepolitik.',
  buttons: {
    accept: 'Accepter',
    reject: 'Afvis',
  },
};
